import {
  Icon,
  RadioButton,
  Tag,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import type { ISavedCardResponse } from '@/modules/perseo-billing/interfaces';

interface PickCardListProps {
  savedCards: ISavedCardResponse[];
  selectedToken: string | null;
  onChange: (value: string) => void;
}

const CARD_ICONS = {
  cencosud: 'pm-cencosud-card',
  visa: 'pm-visa',
  master: 'pm-mastercard',
  generic: 'pm-generic-card'
} as const;

type IconNameType = (typeof CARD_ICONS)[keyof typeof CARD_ICONS];

const getCardIcon = (brand: string): IconNameType => {
  const normalizedBrand = brand.toLowerCase();
  if (normalizedBrand.includes('cencosud')) return CARD_ICONS?.cencosud;
  if (normalizedBrand.includes('visa')) return CARD_ICONS?.visa;
  if (normalizedBrand.includes('master')) return CARD_ICONS?.master;
  return CARD_ICONS?.generic;
};

const getCardLabel = (isExpired?: boolean): string => {
  return isExpired ? 'Crédito (expirada)' : 'Crédito';
};

export const PickCardList = ({
  savedCards,
  selectedToken,
  onChange
}: PickCardListProps) => {
  return (
    <div className="co-flex co-flex-col co-gap-4">
      {savedCards.map((card) => {
        const isExpired = card?.isExpired;
        const isSelected = selectedToken === card?.token;
        const isDisabled = isExpired;

        return (
          <div
            key={card.token}
            className={`co-flex co-items-center co-gap-[12px] co-p-[16px] co-border co-rounded-[16px] ${
              isSelected ? 'co-border-primary-500' : 'co-border-neutral-300'
            } ${isDisabled ? 'co-bg-neutral-200 co-grayscale' : ''}`}
          >
            <RadioButton
              checked={isSelected}
              onChange={() => !isDisabled && onChange(card?.token)}
              name="pick-card"
              value={card?.token}
              variant="card"
              label=" "
              className="co-bottom-2.5"
              disabled={isDisabled}
            />
            <div className={isDisabled ? 'co-grayscale' : ''}>
              <Icon name={getCardIcon(card?.brand)} className="co-h-[27px]" />
            </div>
            <Tag variant={isExpired ? 'urgency' : 'information'} size="md">
              {getCardLabel(isExpired)}
            </Tag>
            <Text weight={400} className="co-text-[13px]">
              ****{card?.lastDigits}
            </Text>
          </div>
        );
      })}
    </div>
  );
};
